/* eslint-disable no-unused-vars */
const chatHistory = [
  {
    role: "system",
    content: "You are Shelf21's helpful assistant."
  }
];

// Functional logic inside the class
async function handleUserMessageFn(message, createChatBotMessage, setState) {
  // Add user message to history
  chatHistory.push({ role: "user", content: message });

  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/admin/v1/webchat/support`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ messages: chatHistory })
    });

    const data = await res.json();

    chatHistory.push({ role: "assistant", content: data.message });

    const botMessage = createChatBotMessage(data.message);
    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, botMessage]
    }));
  } catch (err) {
    const errorMessage = createChatBotMessage("Sorry, something went wrong.");
    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, errorMessage]
    }));
  }
}

class ActionProvider {
  constructor(createChatBotMessage, setStateFunc) {
    this.createChatBotMessage = createChatBotMessage;
    this.setState = setStateFunc;
  }

  handleUserMessage(message) {
    handleUserMessageFn(message, this.createChatBotMessage, this.setState);
  }
}

export default ActionProvider;
